import { getTopProviderAndPlanar } from "../../api/homepage.api";

export const getTopThreeProviderAndPlanner = async (dispatch: any) => {
  let topPlanners = [];
  let topProviders = [];
  try {
    const storedLocation = localStorage.getItem("user_location");
    let latitude = 0;
    let longitude = 0;

    if (storedLocation) {
      const loc = JSON.parse(storedLocation);
      latitude = loc.latitude;
      longitude = loc.longitude;
    }
    const response = await getTopProviderAndPlanar({ longitude, latitude });
    if (response.data.success) {
      topProviders = response.data?.data?.data?.provider || [];
      topPlanners = response.data?.data?.data?.planner || [];
    }
  } catch (error) {}
  dispatch({
    type: "SEARCH:SET_TOP_PARTNER",
    payload: {
      topProviders,
      topPlanners,
    },
  });
};
